module.exports = __webpack_public_path__ + "img/user_profil.5ac9516d.jpg";